import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { PartnershipFormComponent } from './partnership-form/partnership-form.component';
import { PartnershipComponent } from './partnership.component';
import { PartnershipDetailComponent } from './partnership-detail/partnership-detail.component';
import { PartinershipRoutingModule } from './partnership-routing.module';

@NgModule({
  declarations: [
    PartnershipComponent, 
    PartnershipFormComponent, 
    PartnershipDetailComponent
  ],
  imports: [
    SharedModule,
    PartinershipRoutingModule
  ]
})
export class PartnershipModule { }
